<style lang="less" scoped>
@import '../../../style/common/variable';
ul,li {margin: 0;padding: 0;list-style: none;}
.rcep{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
.center {width: 1200px;margin: auto;display: flex;justify-content: space-between;}
.gov-site-left {width: 280px;height: 256px;}
.gov-leader {border: 1px solid #e5e8ea;box-sizing: border-box;}
.leader-title {background: #035294;font-size: 18px;color: #fff;height: 50px;line-height: 50px;margin: 0;}
.more-child-list {width: 280px;text-align: left;}
.more-child-list-li {border-bottom: 1px dotted #ccc;font-size: 16px;line-height: 45px;padding-left: 65px;display: flex;}
.more-child-list-li-img {width: 16px;height: 16px;margin-top: 15px}
.more-child-list-li-span {margin-left: 10px;cursor: pointer;}
.second-gird {margin-bottom: 40px;}
.more-chlid-title {border-bottom: 1px solid #025193;height: 40px;line-height: 40px;overflow: hidden;margin-bottom: 10px;display: flex;justify-content: space-between;}
.more-chlid-title strong {background: #025193;color: #fff;cursor: pointer;padding: 0 30px;font-size: 16px;font-weight: normal;}
.more-chlid-title span {color: #434242;font-size: 14px;cursor: pointer;}
.more-chlid-title .fn-right {margin-right: 15px;}
.txt-list li {display: flex;justify-content: space-between;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;line-height: 40px;padding-left: 15px;background: url(../../../../static/images/zlkindex/dian2.png) 0 14px no-repeat;}
.txt-list li span {cursor: pointer;}
.time {margin-right: 15px;}
@media screen and (max-width: @max-screen){
  .gov-site-right{width: 96vw !important; margin-left: 2vw;
    .txt-list{
      .title{overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 63%; text-align: left;}
    }
  }
}
</style>

<template>
  <div class="gov-site-right" :style="{width: widthCSH + 'px'}">
    <div class="second-gird" v-for="(item, index) in catiddata" :key="index">
      <h2 class="more-chlid-title">
        <strong>{{ item.dispc }}</strong>
        <span class="fn-right" @click="goList(item)">更多&gt;&gt;</span>
      </h2>
      <ul class="txt-list">
        <li v-for="(item1, index1) in item.children" :key="index1">
          <span class="title" @click="goDetails(item1)">{{ item1.title }}</span>
          <span class="time">{{ item1.addtime * 1000 | formatDate() }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * Rcep列表组件
 */
import filters from '../method/filter.js'
export default {
  props: ['catiddata', 'widthCSH'],
  mixins: [filters],
  data()
  {
    return {
    }
  },
  created()
  {
  },
  methods: {
    goList(item)
    {
      let url = this.$router.resolve({path: '/RcepLB', query: {catid: item.id}})
      window.open(url.href, '_blank')
    },
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/RcepDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/RcepList.vue